import styled from 'styled-components';
import colors from '../../config/colors';

const Button = styled.button`
  display: inline-block;
  background: ${colors.ORANGE_COLOR};
  border: none;
  border-radius: 10px;
  color: ${colors.WHITE_COLOR};
  padding: 12px 20px;
  font-size: 14px;
  cursor: pointer;
  text-align: center;
  border: 1px solid ${colors.ORANGE_COLOR};
  transition: all 100ms ease-in-out;
  max-width: 100%;
  position: relative;

  img, svg {
    display: inline-block;
    vertical-align: middle;
    position: relative;
    margin-right: 12px;
    transition: all 100ms ease-in-out;
    fill: ${colors.WHITE_COLOR};
  }

  > span {
    vertical-align: middle;
  }

  &:hover {
    background: ${colors.WHITE_COLOR};
    color: ${colors.ORANGE_COLOR};

    svg {
      fill: ${colors.ORANGE_COLOR};
    }
  }
`;

export default Button;
